import type { StatusVariants } from "@/components/molecules";
import type { PaginatedResponse } from "@/types/api";

export enum UserLevel {
  GROUP = "GROUP",
  BRAND = "BRAND",
  BRANCH = "BRANCH",
}

export enum UserRole {
  ADMIN = "ADMIN",
  NO_ROLE = "no_role",
}

export enum UsersStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  PENDING = "PENDING",
}

export const usersStatusMap: Record<string, UsersStatus> = {
  Active: UsersStatus.ACTIVE,
  Inactive: UsersStatus.INACTIVE,
  Pending: UsersStatus.PENDING,
};

export const USERS_STATUS_VARIANT_MAP: StatusVariants = {
  Active: { badge: "success", dot: "#65A30D" },
  Inactive: { badge: "default", dot: "#111827" },
  Pending: { badge: "info", dot: "#D97706" },
};

export interface IUserInvite {
  level: UserLevel;
  entityIds: string[];
  invites: Array<{ email: string; roleId: UserRole }>;
}

export interface IUser {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  groups: string[];
  brands: string[];
  branches: string[];
  createdAt: string;
  lastActivityAt: string | null;
  status: UsersStatus;
  role: UserRole;
  assignments: AssignedRole[];
}

export interface IUserBasicInfo {
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber?: string | null;
  phone?: string;
  status: UsersStatus;
}

export interface AssignedRole {
  id: string;
  level: UserLevel;
  role: UserRole;
  roleName: string;
  roleId: string;
  roleActive: boolean;
  name: string;
  entityId: string;
}

export type AdminDinerResponse = PaginatedResponse<AssignedRole>;

export type IUserDetails = IUserBasicInfo & {
  id: string;
  accountId: string;
  createdAt: string;
  lastActivityAt: string;
  assignedRoles: AssignedRole;
};

export interface AssignmentsUserRole {
  level: UserLevel;
  role: UserRole;
  entityIds?: string[];
}

export type NewAssignmentRoleResponse = {
  uniqueFailedIds: string[];
};

export type InvitationResponse = {
  unknownErrors: string[];
  failedToSendInvitations: string[];
  usersExists: string[];
  pendingEntityNames: string[];
};
